import React, { useMemo, useState, useEffect, useRef, Suspense } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClock } from "@fortawesome/free-solid-svg-icons";
import { FixedSizeList as List } from "react-window";
import ReactToPrint from "react-to-print";
import { useNavigate } from "react-router-dom";
import { Container, Row, Col, Accordion, Tabs, Tab, Spinner, Alert } from "react-bootstrap";
import { groupAndAverageTasks } from "../services/GroupAndAverageTasks";
import {
  getClass,
  getClassAssessments,
  getTeachers,
  getResultsByStudent,
  getClassesAssessmentResults,
  getIndividualStudentResults,
} from "../services/APIClient";
import "./SencoStudentsResultsOverview.css";
import { Fallback, BigSpinner } from "../services/SpinnerComponent";
import { groupClassResults } from "../services/GroupAndAverageTasks";

import SENWatchlistButton from "./SENWatchlistButton";
import ReportActionCard from "./ReportActionCard";
import ActionCard from "./ActionCard";
import DeleteAnswerModal from "./DeleteAnswerModal";
import ShareActionCard from "./ShareActionCard"; // Import ShareActionCard
import PrintActionCardSenco from "./PrintActionCardSenco"; // Import the new component
// Lazy-loaded components
const SencoAssessmentDropdown = React.lazy(() =>
  import("./SencoAssessmentDropdown")
);
const SencoStudentsResultsTable = React.lazy(() =>
  import("./SencoStudentsResultsTable")
);
const RecommendationsButton = React.lazy(() =>
  import("./RecommendationsButton")
);

const ReturnToSencoResults = React.lazy(() => import("./ReturnToSencoResults"));
const SencoTaskScoreGraph = React.lazy(() => import("./SencoTaskScoreGraph"));
const PieThresholdGraph = React.lazy(() => import("./PieThresholdGraph"));
const ClassroomAnalysis = React.lazy(() => import("./ClassroomAnalysis"));
const TaskScoresComparisonChart = React.lazy(() =>
  import("./TaskScoresComparisonChart")
);

const ClassroomProgressTabContent = React.lazy(() =>
  import("./ClassroomProgressTabContent")
);

const ScreenerPointProgressPieChart = React.lazy(() =>
  import("./ScreenerPointProgressPieChart")
);

const ClassPieCharts = React.lazy(() =>
  import("./ClassPieCharts")
);

const ScreenerPieCharts = React.lazy(() =>
  import("./ScreenerPieCharts")
);

const TaskScoresComparisonChartSchool = React.lazy(() =>
  import("./TaskScoresComparisonChartSchool")
);
const StudentPerformancePieChart = React.lazy(() =>
  import("./StudentPerformancePieChart")
);
const AllStudentsPerformancePieChart = React.lazy(() =>
  import("./AllStudentsPerformancePieChart")
);

const NotScreenedTab = React.lazy(() => import("./NotScreenedTab"));

const AllStudentsIndividualSearch = React.lazy(() =>
  import("./AllStudentsIndividualSearch")
);
const StandardScoresGraph = React.lazy(() => import("./StandardScoresGraph"));
const ScoreStatements = React.lazy(() => import("./ScoreStatements"));
const CandyBearAnalysisGraph = React.lazy(() =>
  import("./CandyBearAnalysisGraph")
);

const CandyBearAnalysisGraphClassComparison = React.lazy(() =>
  import("./CandyBearAnalysisGraphClassComparison")
);

const CandyBearAnalysisGraphClassAll = React.lazy(() =>
  import("./CandyBearAnalysisGraphClassAll")
);

const CandyBearAnalysisGraphClassAverage = React.lazy(() =>
  import("./CandyBearAnalysisGraphClassAverage")
);

const ScoreInterpretationTable = React.lazy(() =>
  import("./ScoreInterpretationTable")
);
const TaskDetailChart = React.lazy(() => import("./TaskDetailChart"));
const StudentPerformancePrintViewAlphabetical = React.lazy(() =>
  import("./StudentPerformancePrintViewAlphabetical")
);

function SencoStudentsResultsOverview(props) {
  const {
    // classesResults = {},
    toggleScoreType,
    showAtRiskOnly,
    schoolid,
    teacherid,
    classIds,
    allClassesAssessments,
    assessment,
    classList,
  } = props;


  const [classDetails, setClassDetails] = useState(null);
  const [activeAccordionClassId, setActiveAccordionClassId] = useState(null);
  const [classAssessments, setClassAssessments] = useState(null);
  const [studentResults, setStudentResults] = useState([]);
  const [students, setStudents] = useState([]);
  const [teachers, setTeachers] = useState(null);
  const [gradeLevel, setGradeLevel] = useState(null);
  const [selectedChild, setSelectedChild] = useState(null);
  const [selectedChildID, setSelectedChildID] = useState("");
  const [individualStudentResult, setIndividualStudentResult] = useState("");
  const [selectedTask, setSelectedTask] = useState(null);
  const [selectedTaskData, setSelectedTaskData] = useState(null);
  const [isTaskDetailVisible, setIsTaskDetailVisible] = useState(false);
  const [showPrintView, setShowPrintView] = useState(false);
  const [showStudentPerformancePrintView, setShowStudentPerformancePrintView] =
    useState(false);
  const [showChildPrintOptions, setShowChildPrintOptions] = useState(false);
  const [selectedAssessment, setSelectedAssessment] = useState(
    assessment || {}
  );
  const [isLoading, setIsLoading] = useState(true);
  const [classesResults, setClassesResults] = useState({});
  const [loadingClassId, setLoadingClassId] = useState(null);
  const [assessmentResultsByStudent, setAssessmentResultsByStudent] = useState(
    []
  );

  const [activeTab, setActiveTab] = useState("overview");
  const [refreshTrigger, setRefreshTrigger] = useState(0);
  const [activeAccordionKey, setActiveAccordionKey] = useState(null);

  const [progressTabLoaded, setProgressTabLoaded] = useState(false);
  const [openedAccordions, setOpenedAccordions] = useState(new Set());

  useEffect(() => {
    if (props.location?.state?.currentTab) {
      setActiveTab(props.location.state.currentTab);
    }
  }, [props.location?.state?.currentTab]);

  useEffect(() => {
    if (props.location?.state?.assessment) {
      setSelectedAssessment(props.location.state.assessment);
    }
  }, [props.location?.state?.assessment]);

  // Add these to your existing state
  const [accordionSelectedClass, setAccordionSelectedClass] = useState(null);
  const [accordionCardPosition, setAccordionCardPosition] = useState({
    top: 0,
    left: 0,
  });
  const [classTaskList, setClassTaskList] = useState([]);
  const [selectedClassTasks, setSelectedClassTasks] = useState([]);
  const [selectAllClassTasks, setSelectAllClassTasks] = useState(false);
  const [showClassTaskList, setShowClassTaskList] = useState(false);
  const [showClassDeleteModal, setShowClassDeleteModal] = useState(false);
  const [classTaskToDelete, setClassTaskToDelete] = useState(null);
  const accordionActionCardRef = useRef(null);

  const isStaging = window.location.href.includes("staging") ||
    window.location.href.includes("localhost") ||
    window.location.href.includes("alpaca-assessment-test");

    // const isStaging = window.location.href.includes("localhost") ||
    // window.location.href.includes("alpaca-assessment-test");


  const [shareCardPosition, setShareCardPosition] = useState({
    top: 0,
    left: 0,
  });

  const [printActionCardPosition, setPrintActionCardPosition] = useState({
    top: 0,
    left: 0,
  });

  // State to track the currently open card
  const [openCard, setOpenCard] = useState(null);

  const getProgressTabStatus = () => {
    const now = new Date();
    const irishTime = new Date(now.toLocaleString("en-US", { timeZone: "Europe/Dublin" }));
    const currentHour = irishTime.getHours();
    const currentMinute = irishTime.getMinutes();
    const dayOfWeek = irishTime.getDay(); // 0 = Sunday, 1 = Monday, ..., 6 = Saturday

    // Check if it's a weekday (Monday = 1, Friday = 5)
    const isWeekday = dayOfWeek >= 1 && dayOfWeek <= 5;

    // Progress tabs are available after 1:30 PM on weekdays, or anytime on weekends
    const isAvailable = !isWeekday ||
      (currentHour > 13) ||
      (currentHour === 13 && currentMinute >= 30);

    return {
      isAvailable,
      currentTime: irishTime.toLocaleTimeString("en-IE", {
        hour: '2-digit',
        minute: '2-digit',
        hour12: false
      }),
      dayOfWeek: irishTime.toLocaleDateString("en-IE", { weekday: 'long' })
    };
  };

  // Function to toggle a card's open state
  const toggleCard = (cardName) => {
    setOpenCard((prevCard) => (prevCard === cardName ? null : cardName));
  };

  // In the handleAccordionActionClick function, change this:

  const handleAccordionActionClick = (event, classId, className, index) => {
    // CRITICAL: Stop all event propagation immediately
    event.stopPropagation();
    event.preventDefault();

    // Ensure the accordion stays open by setting the active key FIRST
    setActiveAccordionKey(String(classId)); // Use classId, not index
    setActiveClassName(className);
    setActiveAccordionClassId(classId);

    // Load data if needed BEFORE setting up the action card
    if (!classesResults[classId]) {
      handleClick(classId);
      // Return early and let the user click again after data loads
      return;
    }

    // Now that we're sure the accordion is open and data is loaded,
    // get all student IDs for this class
    const classStudents = classesResults[classId]?.students || {};
    const studentIds = Object.keys(classStudents);

    // Only proceed if we have student data
    if (studentIds.length === 0) {
      console.warn("No students found for class:", classId);
      return;
    }

    // Set accordion selected class with student IDs
    setAccordionSelectedClass({
      id: studentIds, // Array of student IDs
      name: className,
      classId: classId, // Keep class ID for reference
    });

    // Position action card
    const rect = event.currentTarget.getBoundingClientRect();
    setAccordionCardPosition({
      top: rect.top + window.scrollY,
      left: rect.left - 300,
    });

    // Extract tasks
    const classTasks = extractClassTasks(classId);
    setClassTaskList(classTasks);

    // Reset selections
    setSelectedClassTasks([]);
    setSelectAllClassTasks(false);
    setShowClassTaskList(false);

    // Update activeAccordionStudents immediately
    const students = classesResults[classId].students;
    const studentArray = Object.entries(students).map(([id, student]) => ({
      id,
      name: student.name,
    }));
    setActiveAccordionStudents(studentArray);
  };

  const extractClassTasks = (classId) => {
    if (!classesResults[classId] || !classesResults[classId].students) {
      return [];
    }

    // Map to store unique task names and their associated answer IDs
    const taskMap = new Map();
    // Set to track all answer IDs to avoid duplicates
    const processedAnswerIds = new Set();

    const students = classesResults[classId].students;
    Object.values(students).forEach((student) => {
      student.results?.forEach((result) => {
        // Check for originalTasks
        if (result.originalTasks) {
          result.originalTasks.forEach((task) => {
            // Only process each answer ID once
            if (!processedAnswerIds.has(task.answerid)) {
              processedAnswerIds.add(task.answerid);

              if (!taskMap.has(task.name)) {
                taskMap.set(task.name, {
                  name: task.name,
                  answerIds: [task.answerid],
                });
              } else {
                taskMap.get(task.name).answerIds.push(task.answerid);
              }
            }
          });
        }

        // Also check groupedTasks
        result.groupedTasks?.forEach((group) => {
          group.tasks?.forEach((task) => {
            // Only process each answer ID once
            if (!processedAnswerIds.has(task.answerid)) {
              processedAnswerIds.add(task.answerid);

              if (!taskMap.has(task.name)) {
                taskMap.set(task.name, {
                  name: task.name,
                  answerIds: [task.answerid],
                });
              } else {
                taskMap.get(task.name).answerIds.push(task.answerid);
              }
            }
          });
        });
      });
    });

    // Convert Map to array for the UI
    return Array.from(taskMap.values());
  };

  const handleClassTaskSelection = (taskName) => {
    setSelectedClassTasks((prev) => {
      const updatedTasks = prev.includes(taskName)
        ? prev.filter((name) => name !== taskName)
        : [...prev, taskName];

      setSelectAllClassTasks(updatedTasks.length === classTaskList.length);
      return updatedTasks;
    });
  };

  const handleSelectAllClassTasks = () => {
    if (selectAllClassTasks) {
      setSelectedClassTasks([]);
    } else {
      setSelectedClassTasks(classTaskList.map((task) => task.name));
    }
    setSelectAllClassTasks(!selectAllClassTasks);
  };

  const handleClassRetake = () => {
    if (selectedClassTasks.length === 0) {
      alert("Please select at least one task to retake.");
      return;
    }

    // Collect all answer IDs for the selected tasks and remove duplicates
    const allAnswerIds = [
      ...new Set(
        classTaskList
          .filter((task) => selectedClassTasks.includes(task.name))
          .flatMap((task) => task.answerIds)
      ),
    ];

    // Determine if we're retaking the full assessment or specific tasks
    const isFullAssessment =
      selectAllClassTasks || selectedClassTasks.length === classTaskList.length;

    // Get the name of the task(s) being retaken
    const taskName = isFullAssessment
      ? "Full Assessment"
      : selectedClassTasks.join(", ");

    // Set up data for the delete modal
    setClassTaskToDelete({
      answerIds: allAnswerIds, // This now contains unique answer IDs
      taskName: taskName,
      isFullAssessment: isFullAssessment,
      className: accordionSelectedClass.name,
    });

    setShowClassDeleteModal(true);
    toggleCard("deleteModal");
  };

  const handleClassDeleteSuccess = (taskName, reason) => {
    // Store class ID before closing (which sets accordionSelectedClass to null)
    const classId = accordionSelectedClass?.id;
    const className = accordionSelectedClass?.name;

    // Close UI elements
    handleCloseAccordionCard();
    setShowClassDeleteModal(false);
    toggleCard(null);

    // Add a small delay before reloading data
    if (classId) {
      setTimeout(() => {
        reloadClassData(classId);
      }, 300); // Increased delay for better reliability
    }
  };

  // Close the action card
  const handleCloseAccordionCard = () => {
    setAccordionSelectedClass(null);
    toggleCard(null);
  };

  // Add click outside handler similar to the table component
  useEffect(() => {
    function handleClickOutside(event) {
      if (
        accordionActionCardRef.current &&
        !accordionActionCardRef.current.contains(event.target)
      ) {
        handleCloseAccordionCard();
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const [showPrintCard, setShowPrintCard] = useState(false);
  const [printCardPosition, setPrintCardPosition] = useState({
    top: 0,
    left: 0,
  });

  const [activeAccordionStudents, setActiveAccordionStudents] = useState([]);

  const [activeClassName, setActiveClassName] = useState("");

  const [viewParent, setViewParent] = useState(false);
  const [viewTeacher, setViewTeacher] = useState(false);
  const printCardRef = useRef(null);

  const navigate = useNavigate();

  let fromSencoResults = true;
  const [readingScores, setReadingScores] = useState([]);

  const activeAccordionRef = useRef(null);

  const classRefs = useRef({});
  const individualChildRef = useRef();
  const candyBearRef = useRef();
  const standardScoreGraphRef = useRef();
  const studentPerformancePieRef = useRef();
  const performanceTableRef = useRef();

  const groupedResults = useMemo(
    () => groupAndAverageTasks(assessmentResultsByStudent),
    [assessmentResultsByStudent]
  );

  // Generate unique task names (memoized)
  const taskNameArray = useMemo(() => {
    const taskNames = new Set();
    groupedResults.forEach(({ tasks }) => {
      tasks?.forEach(({ name }) => taskNames.add(name));
    });
    return [...taskNames];
  }, [groupedResults]);

  let name = "Results";
  const rowHeight = 100; // Approximate height of each Accordion row
  const totalClasses = Object.keys(classesResults).length;

  const handleAccordionToggle = (key, ref, className, classId) => {
    const newActiveKey = key === activeAccordionKey ? null : key;
    setActiveAccordionKey(newActiveKey);

    if (newActiveKey) {
      activeAccordionRef.current = ref;
      setActiveClassName(className);
      setActiveAccordionClassId(classId);

      // Update activeAccordionStudents when a new accordion is opened
      const students = classesResults[classId]?.students || {};
      const studentArray = Object.entries(students).map(([id, student]) => ({
        id,
        name: student.name,
      }));
      setActiveAccordionStudents(studentArray);
    } else {
      setActiveClassName("");
      setActiveAccordionClassId(null);
      setActiveAccordionStudents([]); // Clear students when accordion is closed
    }
  };

  const fetchAssessmentResults = async () => {
    try {
      setIsLoading(true); // Set loading state to true when the API call starts
      if (assessment && assessment.instances) {
        const response = await getResultsByStudent(assessment.instances);
        setAssessmentResultsByStudent(response);
      }
    } catch (error) {
      console.error("Error fetching assessment results:", error);
    } finally {
      setIsLoading(false); // Set loading state to false when the API call finishes
    }
  };

  useEffect(() => {
    if (selectedAssessment && selectedAssessment.instances) {
      fetchAssessmentResults(selectedAssessment);
    } else {
      console.warn(
        "Assessment instances missing or selectedAssessment changed to:",
        selectedAssessment
      );
    }
  }, [selectedAssessment]);

  const fetchTeachers = async () => {
    try {
      const response = await getTeachers(schoolid);
      setTeachers(response);
    } catch (error) {
      console.error("Error fetching teachers:", error);
    }
  };

  useEffect(() => {
    fetchTeachers();
  }, [schoolid]);

  const fetchIndividualStudentResults = async (studentId) => {
    try {
      const response = await getIndividualStudentResults(studentId);
      setIndividualStudentResult(response);
    } catch (error) {
      console.error("Error fetching individual student results:", error);
    }
  };

  useEffect(() => {
    if (selectedChildID) {
      fetchIndividualStudentResults(selectedChildID);
    }
  }, [selectedChildID]);

  const handleTaskClick = (taskName) => {
    // Filter classes to get only those with a score for the selected task
    const taskData = formattedClassData
      .map((classData) => ({
        className: classData.name,
        score: classData.taskScores[taskName],
      }))
      .filter((data) => data.score !== undefined); // Filter out classes without scores

    // Toggle visibility
    if (selectedTask === taskName) {
      setIsTaskDetailVisible(!isTaskDetailVisible); // Toggle visibility
      setSelectedTask(null); // Reset the selected task
      setSelectedTaskData(null); // Reset the selected task data
    } else {
      setSelectedTask(taskName);
      setSelectedTaskData(taskData);
      setIsTaskDetailVisible(taskData.length > 0); // Set visibility based on data length
    }
  };

  const thresholds = {
    "Rhyming": { task: 20, student: 25 },
    "Initial Phoneme": { task: 20, student: 20 },
    "Phoneme Blending": { task: 20, student: 20 },
    "Letter Name": { task: 20, student: 15 },
    "Deletion": { task: 20, student: 20 },
    "Letter Sound": { task: 20, student: 20 },
    "Word Reading": { task: 10, student: 15 },
    "Nonword Reading": { task: 10, student: 15 },
    "Non Word Reading": { task: 10, student: 15 },
    "Phonological Awareness": { task: 10, student: 15 },
    "Spelling": { task: 20, student: 20 },
    "Comprehension & Expressive Vocab": { task: 20, student: 20 },
    "Alphabetic Knowledge": { task: 40, student: 20 },
    "Alphabetic Knowledge (a)": { task: 40, student: 20 },
  };

  const planningSetThresholds = {
    "Rhyming": { task: 20, student: 20 },
    "Initial Phoneme": { task: 20, student: 20 },
    "Phoneme Blending": { task: 20, student: 20 },
    "Letter Name": { task: 20, student: 20 },
    "Deletion": { task: 20, student: 20 },
    "Letter Sound": { task: 20, student: 20 },
    "Word Reading": { task: 20, student: 20 },
    "Nonword Reading": { task: 20, student: 20 },
    "Non Word Reading": { task: 20, student: 20 },
    "Phonological Awareness": { task: 20, student: 20 },
    "Spelling": { task: 20, student: 20 },
    "Comprehension & Expressive Vocab": { task: 20, student: 20 },
    "Alphabetic Knowledge": { task: 20, student: 20 },
    "Alphabetic Knowledge (a)": { task: 20, student: 20 },
  };

  console.log(classesResults);

  const formattedClassData = useMemo(() => {
    console.log("formattedClassData: classList", classList);
    console.log("formattedClassData: classesResults", classesResults);

    const initialData = classList
      .filter(({ classId, name }) => classId && name)
      .reduce(
        (acc, { classId, name }) => ({
          ...acc,
          [classId]: {
            id: classId,
            name,
            taskScores: {},
            assessmentResults: [],
          },
        }),
        {}
      );

    Object.entries(classesResults).forEach(([classId, classObj]) => {
      if (!classId || !classObj || !initialData[classId]) {
        console.warn("Skipping invalid class entry", { classId, classObj });
        return;
      }

      const students = classObj.students || {};
      const classTaskScores = {};

      Object.entries(students).forEach(([studentId, student]) => {
        student.results?.forEach((result) => {
          result.groupedTasks?.forEach((group) => {
            if (!group.name || !group.aggregated) {
              console.warn("Skipping invalid groupedTask", {
                group,
                studentId,
              });
              return;
            }

            const taskName = group.name;
            const score = toggleScoreType
              ? group.aggregated.groupPercentile
              : group.aggregated.score * 100;

            if (!classTaskScores[taskName]) {
              classTaskScores[taskName] = [];
            }
            classTaskScores[taskName].push(score);
          });
        });
      });

      // Log task scores before averaging
      console.log(
        `Class ${classId} (${initialData[classId].name}) taskScores before averaging:`,
        classTaskScores
      );

      Object.keys(classTaskScores).forEach((taskName) => {
        const scores = classTaskScores[taskName];
        if (scores.length > 0) {
          const averageScore =
            scores.reduce((a, b) => a + b, 0) / scores.length;
          classTaskScores[taskName] = averageScore.toFixed(2);
        } else {
          delete classTaskScores[taskName];
        }
      });

      // Log task scores after averaging
      console.log(
        `Class ${classId} (${initialData[classId].name}) taskScores after averaging:`,
        classTaskScores
      );

      const validAssessmentResults = Object.entries(students)
        .map(([studentId, student]) => {
          const tasks =
            student.results?.flatMap((result) => result.groupedTasks || []) ||
            [];
          const studentObj = { ...student, id: studentId };
          if (!studentObj.id || tasks.length === 0) {
            console.warn("Skipping student with no id or tasks", {
              studentObj,
              tasks,
            });
          }
          return {
            student: studentObj,
            tasks,
          };
        })
        .filter(({ student, tasks }) => student.id && tasks.length > 0);

      // Log valid assessment results for this class
      console.log(
        `Class ${classId} (${initialData[classId].name}) validAssessmentResults:`,
        validAssessmentResults
      );

      initialData[classId] = {
        ...initialData[classId],
        taskScores: classTaskScores,
        assessmentResults: validAssessmentResults,
      };
    });

    const filteredData = Object.values(initialData).filter(
      (data) => data.id && data.name
    );
    console.log("formattedClassData: final filteredData", filteredData);

    return filteredData;
  }, [classList, classesResults, toggleScoreType]);

  const allStudentsResults = useMemo(() => {
    return Object.values(classesResults)
      .flatMap((classObj) => {
        return Object.entries(classObj.students).map(([id, student]) => {
          const studentData = {
            student: { name: student.name, id: id },
            tasks: student.results
              ? student.results.flatMap((result) => {
                return result.tasks || [];
              })
              : [],
          };

          return studentData;
        });
      })
      .filter((student) => {
        return student.tasks.length > 0; // Filter out students with no tasks
      });
  }, [classesResults]);

  console.log(allStudentsResults, "ALL STUDENTS RESULTS");

  console.log(
    "DEBUG: assessmentResultsByStudent structure sample:",
    assessmentResultsByStudent.length > 0
      ? {
        sample: assessmentResultsByStudent[0],
        tasksSample: assessmentResultsByStudent[0]?.tasks?.slice(0, 2),
      }
      : "No assessment results available"
  );

  // Debug data generation
  console.log("PARENT COMPONENT DATA PREPARATION:");
  console.log("classesResults structure:", Object.keys(classesResults));

  const averageStandardScoresPerTask = useMemo(() => {
    console.log("DEBUG: Calculating averageStandardScoresPerTask");
    console.log(
      "START: School-wide calculation, number of classes:",
      Object.keys(classesResults).length
    );

    // Create a map to store task-based scores for each task
    const taskScores = {};

    // Flatten student data and collect scores per task
    Object.values(classesResults).forEach((classObj) => {
      console.log(
        `Processing class: ${classObj.name}, student count:`,
        Object.keys(classObj.students || {}).length
      );
      // Loop through all students in each class
      Object.entries(classObj.students || {}).forEach(([id, student]) => {
        // Loop through all results for each student
        student.results?.forEach((result) => {
          // Important: Look for groupedTasks instead of tasks
          result.groupedTasks?.forEach((group) => {
            if (!group.name || !group.aggregated) return;

            // Initialize the array for this task if it doesn't exist
            if (!taskScores[group.name]) {
              taskScores[group.name] = [];
            }

            // Add the standardScore from aggregated data if valid
            if (
              group.aggregated.standardScore !== undefined &&
              !isNaN(group.aggregated.standardScore)
            ) {
              taskScores[group.name].push(group.aggregated.standardScore);
            }
          });
        });
      });
    });

    // Calculate the average standardScore for each task
    const averageStandardScores = Object.keys(taskScores).map((taskName) => {
      const scores = taskScores[taskName];
      if (scores.length === 0) {
        return { taskName, averageStandardScore: 0 };
      }
      const sum = scores.reduce((sum, score) => sum + score, 0);
      const averageStandardScore = sum / scores.length;
      return { taskName, averageStandardScore };
    });

    return averageStandardScores;
  }, [classesResults]);

  const averageTaskScores = useMemo(() => {
    const classAverages = {}; // Object to hold average scores for each task by class

    Object.entries(classesResults).forEach(([classId, classObj]) => {
      const students = classObj.students || {};
      const taskScores = {}; // To accumulate scores for this class

      Object.values(students).forEach((student) => {
        const studentResults = student.results || [];
        studentResults.forEach((result) => {
          const tasks = result.tasks || [];
          tasks.forEach((task) => {
            const taskName = task.name;
            const score = toggleScoreType
              ? task.groupPercentile
              : task.score * 100;

            // Initialize the task entry if it doesn't exist
            if (!taskScores[taskName]) {
              taskScores[taskName] = { total: 0, count: 0 };
            }

            // Accumulate the total score and count for each task
            taskScores[taskName].total += score;
            taskScores[taskName].count += 1;
          });
        });
      });

      // Calculate the average score for each task for this class
      const averages = {};
      Object.entries(taskScores).forEach(([taskName, { total, count }]) => {
        averages[taskName] = (total / count).toFixed(2); // Store the average score
      });

      classAverages[classId] = {
        className: classObj.name,
        averages: averages,
      };
    });

    return classAverages;
  }, [classesResults, toggleScoreType]);

  useEffect(() => {
    if (formattedClassData.length > 0) {
      const classId = formattedClassData[0].id; // Extract the classId

      getClass(classId).then((response) => {
        setClassDetails(response);
        setGradeLevel(response.grade_level);
      });

      getClassAssessments(classId).then((response) => {
        setClassAssessments(response);
      });
    }
  }, [formattedClassData]);

  const handleClick = async (classId) => {
    // If class results are already fetched, do nothing
    if (classesResults[classId]) {
      return;
    }

    setLoadingClassId(classId);

    try {
      const response = await getClassesAssessmentResults(
        [classId],
        assessment.id
      );

      // Process the response with groupClassResults before setting state
      const groupedResults = groupClassResults(response);

      setClassesResults((prevResults) => {
        const newResults = {
          ...prevResults,
          ...groupedResults,
        };

        return newResults;
      });
    } catch (error) {
      console.error(`Error fetching data for class ${classId}:`, error);
    } finally {
      setLoadingClassId(null);
    }
  };

  const YEAR_RANGES = {
    "24/25": { start: "2024-08-15", end: "2025-08-15" },
    "23/24": { start: "2023-08-15", end: "2024-08-15" },
    "22/23": { start: "2022-08-15", end: "2023-08-15" },
  };

  function getCurrentAcademicYear(date = new Date()) {
    const currentTimestamp = date.getTime();

    for (const [label, range] of Object.entries(YEAR_RANGES)) {
      const start = new Date(range.start).getTime();
      const end = new Date(range.end).getTime();

      if (currentTimestamp >= start && currentTimestamp < end) {
        return label;
      }
    }

    return "Unknown Year";
  }
  const academicYear = getCurrentAcademicYear();

  useEffect(() => {
    if (classList.length > 0) {
      const firstClassId = classList[0].classId; // Get the ID of the first class
      const firstClassName = classList[0].name; // Get the name of the first class
      setActiveAccordionKey(String(firstClassId)); // Ensure string
      setActiveClassName(firstClassName); // Set the active class name
      setActiveAccordionClassId(firstClassId);

      if (!classesResults[firstClassId]) {
        handleClick(firstClassId); // Fetch results for the first class
      }
    }
  }, [classList]); // Runs whenever classList is updated

  const toAllStudentResults = (selectedStudentIds, viewParent, viewTeacher) => {
    setViewParent(viewParent);
    setViewTeacher(viewTeacher);

    // Validate and filter assessment instances to ensure they are UUIDs
    const validAssessmentInstances = (assessment.instances || []).filter((id) =>
      /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/.test(
        id
      )
    );

    const state = {
      studentResults,
      classDetails,
      classAssessments,
      gradeLevel,
      teachers,
      assessment: {
        ...assessment,
        instances: validAssessmentInstances, // Use only valid UUIDs
      },
      taskNameArray,
      assessmentResultsByStudent: groupedResults,
      toggleScoreType,
      schoolid,
      teacherid,
      viewParent,
      viewTeacher,
      fromSencoResults: true,
      students: students.filter((student) =>
        selectedStudentIds.includes(student.id)
      ), // Filter students based on selected IDs
      readingScores,
    };

    navigate("/allstudents/results", {
      state,
    });
  };

  const toReportCards = (selectedStudentIds) => {
    navigate("/allstudents/reportcards", {
      state: {
        studentResults,
        classDetails,
        classAssessments,
        gradeLevel,
        teachers,
        assessment,
        taskNameArray,
        assessmentResultsByStudent: groupedResults,
        toggleScoreType,
        schoolid,
        teacherid,
        students: students.filter((student) =>
          selectedStudentIds.includes(student.id)
        ), // Filter students based on selected IDs
      },
    });
  };

  const handleAnswerDeleted = (classId) => {
    reloadClassData(classId);
  };

  const reloadClassData = async (classId) => {
    setLoadingClassId(classId);

    try {
      const response = await getClassesAssessmentResults(
        [classId],
        assessment.id
      );

      // Process the response with groupClassResults before setting state
      const groupedResults = groupClassResults(response);

      // Create a completely new object instead of spreading
      setClassesResults((prevResults) => {
        const newResults = { ...prevResults };

        // Explicitly assign the relevant class data
        if (groupedResults[classId]) {
          newResults[classId] = groupedResults[classId];
        }

        return newResults;
      });

      // Force a re-render through the refresh trigger
      setRefreshTrigger((prev) => prev + 1);

      // Force the accordion to be active
      setActiveAccordionKey(classId.toString());
    } catch (error) {
      console.error(`Error fetching data for class ${classId}:`, error);
    } finally {
      setLoadingClassId(null);
    }
  };

  useEffect(() => {
    if (
      activeAccordionClassId &&
      classesResults[activeAccordionClassId]?.students
    ) {
      const students = classesResults[activeAccordionClassId].students;
      const studentArray = Object.entries(students).map(([id, student]) => ({
        id,
        name: student.name,
      }));
      setActiveAccordionStudents(studentArray);
    }
  }, [classesResults, activeAccordionClassId, refreshTrigger]);

  useEffect(() => {
    if (activeTab === "recommendations" && classList.length > 0) {
      console.log("Loading all class data for Insights tab");
      classList.forEach((classItem) => {
        if (!classesResults[classItem.classId]) {
          handleClick(classItem.classId);
        }
      });
    }
  }, [activeTab, classList]);

  const allClassStudents = useMemo(() => {
    const studentList = [];

    Object.entries(classesResults).forEach(([classId, classObj]) => {
      const students = classObj.students || {};

      Object.entries(students).forEach(([studentId, student]) => {
        studentList.push({
          id: studentId,
          name: student.name || "Unknown",
          classId: classId,
        });
      });
    });

    return studentList;
  }, [classesResults]);

  const assessmentIdMapping = {
    junior: {
      baseline: "68ce3a92-73e0-4158-9c08-31bff6246d23", // Junior Baseline Screener
      midpoint: "6a43ae18-2251-4876-8f15-23e2c897fdab", // Junior Midpoint Screener
      endOfYear: "d613e45e-b3b0-4d0f-bcdc-cc17f38bd285", // Junior End of Year Screener
    },
    senior: {
      baseline: "927b2379-998c-4424-af56-1f82e0144765", // Senior Baseline Screener
      midpoint: "9b962947-4f59-4e19-a725-40601b66e8ff", // Senior Midpoint Screener
      endOfYear: "08e97976-f32f-4ad6-a2df-7a2be0789d70", // Senior End of Year Screener
    },
  };

  let grade_level2 = classDetails?.grade_level2 || false; // Default to false if not available

  // Determine the grade level dynamically
  const gradeLevelKey = grade_level2 ? "senior" : "junior"; // Use grade_level2 for seniors, otherwise juniors

  // Get the assessment IDs for the current grade level
  const selectedAssessmentIds = assessmentIdMapping[gradeLevelKey];

  return isLoading ? (
    <div className="loading-container">
      <div className="spinner-container">
        <div className="big-ball-spinner"></div>
        <p>Loading data, please wait...</p>
      </div>
    </div>
  ) : (
    <>
      <Row className="inline-block align-items-center push-down mt-4">
        <Col className="col-auto">
          <Suspense fallback={<div>Loading Navigation Button...</div>}>
            <ReturnToSencoResults />
          </Suspense>
        </Col>
        <Col className="flex-grow-1 text-center" style={{ margin: "10px" }}>
          <h2 className="page-description-header-results">
            SENCO Results Overview
          </h2>
        </Col>
        <Col
          className="col-auto d-flex justify-content-end align-items-center"
          style={{ gap: "16px" }}
        >
          <Suspense fallback={<div>Loading SEN Watchlist Button...</div>}>
            <SENWatchlistButton
              schoolid={schoolid}
              teachers={teachers}
              teacherid={teacherid}
              assessment={assessment}
              readingScores={readingScores}
            />
          </Suspense>
          <button
            className="print-button"
            style={{ whiteSpace: "nowrap" }}
            onClick={(event) => {
              const rect = event.currentTarget.getBoundingClientRect();
              setPrintCardPosition({
                top: rect.top + window.scrollY,
                left: rect.left - 250,
              });
              toggleCard("printCard");
            }}
          >
            {assessment.name?.split(" ")[1]} Report Cards
            <img
              src={process.env.PUBLIC_URL + "/assets/imgs/chevron-sort.svg"}
              alt="Sort"
              className="print-button-icon"
            />
          </button>

          <button
            className="print-button"
            onClick={(event) => {
              const rect = event.currentTarget.getBoundingClientRect();
              setPrintActionCardPosition({
                top: rect.top + window.scrollY,
                left: rect.left - 250,
              });
              toggleCard("printActionCard");
            }}
          >
            Print
            <img
              src={process.env.PUBLIC_URL + "/assets/imgs/chevron-sort.svg"}
              alt="Sort"
              className="print-button-icon"
            />
          </button>
          <button
            className="print-button"
            onClick={(event) => {
              const rect = event.currentTarget.getBoundingClientRect();
              setShareCardPosition({
                top: rect.top + window.scrollY,
                left: rect.left - 250,
              });
              toggleCard("shareCard");
            }}
          >
            Share
            <img
              src={process.env.PUBLIC_URL + "/assets/imgs/chevron-sort.svg"}
              alt="Sort"
              className="print-button-icon"
            />
          </button>
        </Col>
      </Row>
      <div className="class-overview-container">
        <div className="senco-results-header">
          {activeClassName}
          {/* <div className="container-shape-senco"></div> */}
        </div>
        <div className="bottom-container">
          <Container className="container-shape-senco">
            <Suspense fallback={<div>Loading tabs...</div>}>
              <Tabs
                defaultActiveKey="overview"
                id="senco-results-tabs"
                className="mb-3"
              >
                {/* First Tab with the Accordion */}
                <Tab eventKey="overview" title="Class Results">
                  <Row className="page-description-bar align-items-center">
                    <Col className="col-auto">
                      <Suspense
                        fallback={<div>Loading Assessment Dropdown...</div>}
                      >
                        <SencoAssessmentDropdown
                          classAssessments={classAssessments}
                          classIds={classIds}
                          teachers={teachers}
                          assessmentName={assessment.name}
                          assessment={assessment}
                          teacherid={teacherid}
                          schoolid={schoolid}
                          gradeLevel={gradeLevel}
                          allClassesAssessments={allClassesAssessments}
                          assessmentResultsByStudent={
                            assessmentResultsByStudent
                          }
                          fromSencoResults={fromSencoResults}
                          setReadingScores={setReadingScores}
                        />
                      </Suspense>
                    </Col>
                    <Col className="d-flex justify-content-end align-items-center">
                      <Suspense
                        fallback={<div>Loading Recommendations...</div>}
                      >
                        <RecommendationsButton onResultsPage={true} />
                      </Suspense>
                      <Suspense fallback={<div>Loading score table...</div>}>
                        <ScoreInterpretationTable />
                      </Suspense>
                    </Col>
                  </Row>
                  <Row>
                    <Col className="col-5"></Col>
                  </Row>
                  {isLoading ? (
                    <div className="spinner-container">
                      <div className="big-ball-spinner"></div>
                    </div>
                  ) : (
                    <Accordion
                      activeKey={activeAccordionKey}
                      onSelect={(key) => setActiveAccordionKey(key)}
                      className="accordion-container"
                    >
                      {classList.map((classItem, index) => {
                        const { classId, name } = classItem; // Extract classId and name from the class list
                        if (name.toUpperCase().includes("SET")) {
                          return null;
                        }
                        return (
                          <Accordion.Item
                            eventKey={String(classId)}
                            key={classId}
                            className="accordion-item-results"
                          >
                            <Accordion.Header
                              onClick={(e) => {
                                // Only handle accordion toggle if the click is NOT on the actions icon
                                if (!e.target.closest(".accordion-actions-icon")) {
                                  handleAccordionToggle(
                                    String(classId),
                                    activeAccordionRef,
                                    name,
                                    classId
                                  );
                                  handleClick(classId);
                                }
                              }}
                              className="accordion-header"
                            >
                              <div className="d-flex justify-content-between w-100 align-items-center">
                                <span>{name}</span>
                                <div className="d-flex align-items-center">
                                  <span
                                    className="accordion-actions-icon"
                                    onClick={(e) => {
                                      // CRITICAL: Stop all propagation
                                      e.stopPropagation();
                                      e.preventDefault();

                                      handleAccordionActionClick(e, classId, name, index);
                                      toggleCard("actionCard");
                                    }}
                                    style={{
                                      // Make sure the clickable area is well defined
                                      padding: "8px",
                                      cursor: "pointer",
                                      zIndex: 10
                                    }}
                                  >
                                    <img
                                      src={process.env.PUBLIC_URL + "/assets/imgs/dots-vertical.svg"}
                                      alt="Actions"
                                      style={{ pointerEvents: "none" }} // Prevent img from intercepting clicks
                                    />
                                  </span>
                                </div>
                              </div>
                              {loadingClassId === classId && <Fallback />}
                            </Accordion.Header>
                            <Accordion.Body
                              ref={(el) => {
                                if (
                                  activeAccordionKey === String(classId) &&
                                  el
                                ) {
                                  activeAccordionRef.current = el;
                                }
                              }}
                            >
                              {classesResults[classId] ? (
                                <Suspense fallback={<div>Loading table..</div>}>
                                  <SencoStudentsResultsTable
                                    classesResults={{
                                      [classId]: classesResults[classId],
                                    }} // Pass only the relevant class results
                                    toggleScoreType={props.toggleScoreType}
                                    isPrintOut={false}
                                    showAtRiskOnly={showAtRiskOnly}
                                    schoolid={schoolid}
                                    teacherid={teacherid}
                                    classId={classId}
                                    assessment={assessment}
                                    classDetails={classDetails}
                                    readingScores={readingScores}
                                    classAssessments={classAssessments}
                                    teachers={teachers}
                                    gradeLevel={gradeLevel}
                                    assessmentResultsByStudent={
                                      assessmentResultsByStudent
                                    }
                                    fromSencoResults={fromSencoResults}
                                    setActiveAccordionStudents={
                                      setActiveAccordionStudents
                                    } // Pass the function
                                    activeAccordionStudents={
                                      activeAccordionStudents
                                    }
                                    activeAccordionKey={activeAccordionKey}
                                    setStudentResults={setStudentResults}
                                    setStudents={setStudents}
                                    activeAccordionClassId={
                                      activeAccordionClassId
                                    }
                                    students={students}
                                    onAnswerDeleted={handleAnswerDeleted}
                                    toAllStudentResults={toAllStudentResults}
                                    setViewParent={setViewParent}
                                    setViewTeacher={setViewTeacher}
                                  />
                                </Suspense>
                              ) : (
                                <p>No data loaded yet for this class.</p>
                              )}
                            </Accordion.Body>
                          </Accordion.Item>
                        );
                      })}
                    </Accordion>
                  )}
                </Tab>
                {/* Performance Overview Tab */}
                <Tab
                  eventKey="performance"
                  title="Class Analysis"
                  onSelect={(tab) => setActiveTab(tab)}
                  onEnter={() => {
                    // Call handleClick for each class ID when tab is selected
                    classList.forEach((classItem) => {
                      if (!classesResults[classItem.classId]) {
                        // Prevent redundant calls
                        handleClick(classItem.classId);
                      }
                    });
                  }}
                >
                  {" "}
                  <Row className="page-description-bar align-items-center">
                    <Col className="col-auto">
                      <Suspense
                        fallback={<div>Loading Assessment Dropdown...</div>}
                      >
                        <SencoAssessmentDropdown
                          classAssessments={classAssessments}
                          classIds={classIds}
                          teachers={teachers}
                          assessmentName={assessment.name}
                          assessment={assessment}
                          teacherid={teacherid}
                          schoolid={schoolid}
                          gradeLevel={gradeLevel}
                          allClassesAssessments={allClassesAssessments}
                        />
                      </Suspense>
                    </Col>
                    <Col className="d-flex justify-content-end align-items-center">
                      <Suspense
                        fallback={<div>Loading Recommendations...</div>}
                      >
                        <RecommendationsButton onResultsPage={true} />
                      </Suspense>
                      <Suspense fallback={<div>Loading score table...</div>}>
                        <ScoreInterpretationTable />
                      </Suspense>
                    </Col>
                  </Row>
                  <Accordion
                    activeKey={activeAccordionKey}
                    onSelect={(key) => setActiveAccordionKey(key)}
                    className="accordion-container"
                  >
                    {formattedClassData.map((classData) => {
                      // Skip unwanted classes
                      if (classData.name.toUpperCase().includes("SET")) {
                        return null;
                      }
                      // Ensure we get the correct class results
                      const classResults = classesResults[classData.id] || {};
                      // Transform `classResults` to extract `groupedTasks`
                      const transformedAssessmentResults = Object.values(
                        classResults.students || {}
                      )
                        .map((student) => ({
                          student: student, // Keep student details
                          tasks: (student.results || []).flatMap((result) =>
                            result.groupedTasks.map((group) => ({
                              name: group.name, // Use grouped task name
                              score: Math.min(
                                Math.max(group.aggregated?.score ?? 0, 0),
                                1
                              ),
                              standardScore:
                                group.aggregated?.standardScore ?? 0,
                              zScore: group.aggregated?.zScore ?? 0,
                              sTenScore: group.aggregated?.sTenScore ?? 0,
                              duration: group.aggregated?.duration ?? 0,
                            }))
                          ),
                        }))
                        .filter((student) => student.tasks.length > 0); // Remove students without tasks
                      return (
                        <Accordion.Item
                          eventKey={String(classData.id)}
                          key={classData.id}
                        >
                          <Accordion.Header
                            onClick={() =>
                              !classesResults[classData.id] &&
                              handleClick(classData.id)
                            }
                          >
                            {classData.name}
                            {loadingClassId === classData.id && <Fallback />}
                          </Accordion.Header>
                          <Accordion.Body>
                            {classResults ? (
                              <>
                                {/* Render TaskScoreGraph for the current class */}
                                <SencoTaskScoreGraph
                                  tasksData={classData.taskScores} // Already formatted separately
                                  onLabelClick={handleTaskClick}
                                  className={classData.name}
                                  academicYear={academicYear}
                                  assessmentName={assessment.name}
                                />
                                {selectedTask && selectedTaskData && (
                                  <TaskDetailChart
                                    taskName={selectedTask}
                                    data={selectedTaskData}
                                    className={classData.name}
                                    academicYear={academicYear}
                                  />
                                )}
                                {/* Render PieThresholdGraph for the current class */}
                                <PieThresholdGraph
                                  assessmentResults={
                                    transformedAssessmentResults
                                  } // Now correctly formatted
                                  thresholds={thresholds}
                                  fromSencoResults={true}
                                  className={classData.name}
                                />
                                <hr />
                                {/* Render ClassroomAnalysis if assessmentResults exist */}
                                {transformedAssessmentResults.length > 0 && (
                                  <ClassroomAnalysis
                                    assessmentResultsByStudent={
                                      transformedAssessmentResults
                                    }
                                    thresholds={thresholds}
                                  />
                                )}
                              </>
                            ) : (
                              <div>
                                Loading data or select this class to load
                                data...
                              </div>
                            )}
                          </Accordion.Body>
                        </Accordion.Item>
                      );
                    })}
                  </Accordion>
                </Tab>
                {/* Recommendations Tab */}
                <Tab
                  eventKey="recommendations"
                  title="Insights"
                  onSelect={(tab) => setActiveTab(tab)}
                  onEnter={() => {
                    // Call handleClick for each class ID when tab is selected
                    console.log(
                      "Insights tab entered - loading all class data"
                    );
                    classList.forEach((classItem) => {
                      if (!classesResults[classItem.classId]) {
                        // Prevent redundant calls
                        handleClick(classItem.classId);
                      }
                    });
                  }}
                >
                  <Row className="page-description-bar align-items-center">
                    <Col className="col-auto">
                      <Suspense
                        fallback={<div>Loading Assessment Dropdown...</div>}
                      >
                        <SencoAssessmentDropdown
                          classAssessments={classAssessments}
                          classIds={classIds}
                          teachers={teachers}
                          assessmentName={assessment.name}
                          assessment={assessment}
                          teacherid={teacherid}
                          schoolid={schoolid}
                          gradeLevel={gradeLevel}
                          allClassesAssessments={allClassesAssessments}
                        />
                      </Suspense>
                    </Col>
                    <Col className="d-flex justify-content-end align-items-center">
                      <Suspense
                        fallback={<div>Loading Recommendations...</div>}
                      >
                        <RecommendationsButton onResultsPage={true} />
                      </Suspense>
                      <Suspense fallback={<div>Loading score table...</div>}>
                        <ScoreInterpretationTable />
                      </Suspense>
                    </Col>
                  </Row>
                  <Accordion
                    activeKey={activeAccordionKey}
                    onSelect={(key) => setActiveAccordionKey(key)}
                    className="accordion-container"
                  >
                    {formattedClassData.map((classData) => {
                      // Skip certain classes
                      if (classData.name.toUpperCase().includes("SET")) {
                        return null;
                      }
                      // Ensure we get the correct class results
                      const classResults = classesResults[classData.id] || {};
                      // Transform `classResults` to extract `groupedTasks`
                      const transformedAssessmentResults = Object.values(
                        classResults.students || {}
                      )
                        .map((student) => ({
                          student: student, // Keep student details
                          tasks: (student.results || []).flatMap((result) =>
                            result.groupedTasks.map((group) => ({
                              name: group.name, // Use grouped task name
                              standardScore:
                                group.aggregated?.standardScore ?? 0, // Aggregated Standard Score
                              zScore: group.aggregated?.zScore ?? 0,
                              sTenScore: group.aggregated?.sTenScore ?? 0,
                              duration: group.aggregated?.duration ?? 0,
                            }))
                          ),
                        }))
                        .filter((student) => student.tasks.length > 0); // Remove students without tasks

                      console.log("Task comparison data - class specific:", {
                        className: classData.name,
                        studentCount: transformedAssessmentResults.length,
                        taskSample:
                          transformedAssessmentResults[0]?.tasks?.slice(0, 2) ||
                          [],
                      });
                      console.log("Task comparison data - school wide:", {
                        taskCount: averageStandardScoresPerTask?.length,
                        sample: averageStandardScoresPerTask?.slice(0, 3),
                      });

                      return (
                        <Accordion.Item
                          eventKey={String(classData.id)}
                          key={classData.id}
                        >
                          <Accordion.Header
                            onClick={() =>
                              !classesResults[classData.id] &&
                              handleClick(classData.id)
                            }
                          >
                            {classData.name}
                            {loadingClassId === classData.id && <Fallback />}
                          </Accordion.Header>
                          <Accordion.Body>
                            {classResults ? ( // Check if data is loaded
                              <>
                                {transformedAssessmentResults.length > 0 ? (
                                  <TaskScoresComparisonChart
                                    assessmentResultsByStudent={
                                      transformedAssessmentResults
                                    }
                                    fromSencoResults={true}
                                    className={classData.name}
                                    academicYear={academicYear}
                                  />
                                ) : (
                                  <div>
                                    No class data available to display chart
                                  </div>
                                )}

                                <TaskScoresComparisonChartSchool
                                  assessmentResultsByStudent={[]}
                                  fromSencoResults={true}
                                  className={classData.name}
                                  averageStandardScoresPerTask={
                                    averageStandardScoresPerTask
                                  }
                                  academicYear={academicYear}
                                />
                              </>
                            ) : (
                              <div>
                                Loading data or select this class to load
                                data...
                              </div>
                            )}
                          </Accordion.Body>
                        </Accordion.Item>
                      );
                    })}
                  </Accordion>
                </Tab>
                {/* Settings Tab */}
                <Tab
                  eventKey="settings"
                  title="Planning SET"
                  onEnter={() => {
                    classList.forEach((classItem) => {
                      if (!classesResults[classItem.classId]) {
                        handleClick(classItem.classId);
                      }
                    });
                  }}
                >
                  <Row className="page-description-bar align-items-center">
                    <Col className="col-auto">
                      <Suspense
                        fallback={<div>Loading Assessment Dropdown...</div>}
                      >
                        <SencoAssessmentDropdown
                          classAssessments={classAssessments}
                          classIds={classIds}
                          teachers={teachers}
                          assessmentName={assessment.name}
                          assessment={assessment}
                          teacherid={teacherid}
                          schoolid={schoolid}
                          gradeLevel={gradeLevel}
                          allClassesAssessments={allClassesAssessments}
                        />
                      </Suspense>
                    </Col>
                    <Col className="d-flex justify-content-end align-items-center">
                      <Suspense
                        fallback={<div>Loading Recommendations...</div>}
                      >
                        <RecommendationsButton onResultsPage={true} />
                      </Suspense>
                      <Suspense fallback={<div>Loading score table...</div>}>
                        <ScoreInterpretationTable />
                      </Suspense>
                    </Col>
                  </Row>

                  {/* ✅ Apply similar transformation to All Students Performance */}
                  <Accordion defaultActiveKey="all-students">
                    <Accordion.Item eventKey="all-students">
                      <Accordion.Header>
                        All Students Performance
                      </Accordion.Header>
                      <Accordion.Body>
                        <Suspense fallback={<div>Loading chart...</div>}>
                          <AllStudentsPerformancePieChart
                            allStudentsResults={
                              // Collect all students from all classes
                              Object.values(classesResults).reduce((allStudents, classResult) => {
                                // Transform students from this class
                                const studentsFromClass = Object.entries(classResult.students || {})
                                  .map(([studentId, student]) => ({
                                    student: { ...student, id: studentId },
                                    tasks: (student.results || []).flatMap((result) =>
                                      result.groupedTasks.map((group) => ({
                                        name: group.name,
                                        score: group.aggregated?.score ?? 0,
                                        standardScore: group.aggregated?.standardScore ?? 0,
                                        zScore: group.aggregated?.zScore ?? 0,
                                        sTenScore: group.aggregated?.sTenScore ?? 0,
                                        duration: group.aggregated?.duration ?? 0,
                                        order: group.order || 0,
                                      }))
                                    ),
                                  }))
                                  .filter(student => student.tasks.length > 0);

                                // Add these students to our accumulated array
                                return [...allStudents, ...studentsFromClass];
                              }, [])
                            }
                            thresholds={planningSetThresholds}
                            classDetails={formattedClassData}
                            classAssessments={classAssessments}
                            gradeLevel={gradeLevel}
                            teachers={teachers}
                            assessment={assessment}
                            toggleScoreType={toggleScoreType}
                            schoolid={schoolid}
                            teacherid={teacherid}
                            fromSencoResults={fromSencoResults}
                          />
                        </Suspense>
                      </Accordion.Body>
                    </Accordion.Item>
                  </Accordion>

                  <hr />

                  <Accordion
                    activeKey={activeAccordionKey}
                    onSelect={(key) => setActiveAccordionKey(key)}
                    className="accordion-container"
                  >
                    {formattedClassData.map((classData) => {
                      // Skip classes with "SET" in their name
                      if (classData.name.toUpperCase().includes("SET")) {
                        return null;
                      }
                      // Ensure a ref exists for each class
                      classRefs.current[classData.id] =
                        classRefs.current[classData.id] || React.createRef();
                      // ✅ Extract class results from `classesResults`
                      const classResults = classesResults[classData.id] || {};
                      // ✅ Transform `classResults` to extract `groupedTasks`
                      const transformedAssessmentResults = Object.entries(
                        classResults.students || {}
                      )
                        .map(([studentId, student]) => ({
                          student: { ...student, id: studentId }, // Include student id
                          tasks: (student.results || []).flatMap((result) =>
                            result.groupedTasks.map((group) => ({
                              name: group.name,
                              score: group.aggregated?.score ?? 0,
                              standardScore:
                                group.aggregated?.standardScore ?? 0,
                              zScore: group.aggregated?.zScore ?? 0,
                              sTenScore: group.aggregated?.sTenScore ?? 0,
                              duration: group.aggregated?.duration ?? 0,
                            }))
                          ),
                        }))
                        .filter((student) => student.tasks.length > 0);
                      return (
                        <Accordion.Item
                          eventKey={String(classData.id)}
                          key={classData.id}
                        >
                          <Accordion.Header
                            onClick={() =>
                              !classesResults[classData.id] &&
                              handleClick(classData.id)
                            }
                          >
                            {classData.name}
                            {loadingClassId === classData.id && <Fallback />}
                          </Accordion.Header>
                          <Accordion.Body>
                            <Row>
                              <Col className="blue-button-container">
                                <button
                                  className="blue-action-button"
                                  style={{ marginBottom: "16px" }}
                                  onClick={() => {
                                    setShowPrintView(!showPrintView);
                                    setShowStudentPerformancePrintView(
                                      !showPrintView
                                    );
                                  }}
                                >
                                  {showPrintView
                                    ? "Hide Alphabetical Print View"
                                    : "View Alphabetical Print View"}
                                </button>
                              </Col>
                            </Row>
                            {showStudentPerformancePrintView && (
                              <>
                                <ReactToPrint
                                  trigger={() => (
                                    <button className="blue-button">
                                      Print Alphabetical View
                                    </button>
                                  )}
                                  content={() =>
                                    classRefs.current[classData.id].current
                                  }
                                />
                                <div ref={classRefs.current[classData.id]}>
                                  <Suspense
                                    fallback={<div>Loading print...</div>}
                                  >
                                    <StudentPerformancePrintViewAlphabetical
                                      assessmentResultsByStudent={
                                        transformedAssessmentResults
                                      }
                                      thresholds={planningSetThresholds}
                                    />
                                  </Suspense>
                                </div>
                              </>
                            )}
                            {!showPrintView && (
                              <Suspense fallback={<div>Loading chart...</div>}>
                                <StudentPerformancePieChart
                                  assessmentResultsByStudent={
                                    transformedAssessmentResults
                                  } // ✅ Now properly structured
                                  thresholds={planningSetThresholds}
                                  classDetails={classData}
                                  classAssessments={classAssessments}
                                  gradeLevel={gradeLevel}
                                  teachers={teachers}
                                  assessment={assessment}
                                  toggleScoreType={toggleScoreType}
                                  schoolid={schoolid}
                                  teacherid={teacherid}
                                  fromSencoResults={fromSencoResults}
                                />
                              </Suspense>
                            )}
                          </Accordion.Body>
                        </Accordion.Item>
                      );
                    })}
                  </Accordion>


                </Tab>
                {/* Search Tab */}
                <Tab eventKey="results3" title="Individual Child">
                  <Row className="page-description-bar align-items-center">
                    <Col className="col-auto">
                      <Suspense
                        fallback={<div>Loading Assessment Dropdown...</div>}
                      >
                        <SencoAssessmentDropdown
                          classAssessments={classAssessments}
                          classIds={classIds}
                          teachers={teachers}
                          assessmentName={assessment.name}
                          assessment={assessment}
                          teacherid={teacherid}
                          schoolid={schoolid}
                          gradeLevel={gradeLevel}
                          allClassesAssessments={allClassesAssessments}
                        />
                      </Suspense>
                    </Col>
                    <Col className="d-flex justify-content-end align-items-center">
                      <Suspense
                        fallback={<div>Loading Recommendations...</div>}
                      >
                        <RecommendationsButton onResultsPage={true} />
                      </Suspense>
                      <Suspense fallback={<div>Loading score table...</div>}>
                        <ScoreInterpretationTable />
                      </Suspense>
                    </Col>
                  </Row>
                  <button
                    className="blue-button"
                    onClick={() =>
                      setShowChildPrintOptions(!showChildPrintOptions)
                    }
                  >
                    {showChildPrintOptions
                      ? "Hide Print Options"
                      : "View Print Options"}
                  </button>
                  {showChildPrintOptions && (
                    <div className="print-options">
                      <ReactToPrint
                        trigger={() => (
                          <button className="blue-button">
                            Print Individual Child
                          </button>
                        )}
                        content={() => individualChildRef.current}
                      />
                      <ReactToPrint
                        trigger={() => (
                          <button className="blue-button">
                            Print Standard Scores Graph
                          </button>
                        )}
                        content={() => standardScoreGraphRef.current}
                      />
                      <ReactToPrint
                        trigger={() => (
                          <button className="blue-button">
                            Print Progress Between Testing Points
                          </button>
                        )}
                        content={() => candyBearRef.current}
                      />
                    </div>
                  )}
                  <AllStudentsIndividualSearch
                    allStudentsResults={allStudentsResults}
                    selectedChild={selectedChild}
                    setSelectedChild={setSelectedChild}
                  />
                  <hr></hr>
                  <div ref={individualChildRef}>
                    <div ref={standardScoreGraphRef}>
                      <StandardScoresGraph selectedChild={selectedChild} />
                      <ScoreStatements selectedChild={selectedChild} />
                    </div>
                    <hr></hr>
                    <div ref={candyBearRef}>
                      <CandyBearAnalysisGraph
                        selectedChild={selectedChild}
                        setSelectedChildID={setSelectedChildID}
                        individualStudentResult={individualStudentResult}
                      />
                    </div>
                  </div>
                </Tab>
                <Tab
                  eventKey="results4"
                  title="Class Average"
                  className="mb-4"
                  onSelect={(tab) => setActiveTab(tab)}
                  onEnter={() => {
                    // Call handleClick for each class ID when tab is selected
                    classList.forEach((classItem) => {
                      if (!classesResults[classItem.classId]) {
                        // Prevent redundant calls
                        handleClick(classItem.classId);
                      }
                    });
                  }}
                >
                  <Row className="page-description-bar align-items-center">
                    <Col className="col-auto">
                      <Suspense
                        fallback={<div>Loading Assessment Dropdown...</div>}
                      >
                        <SencoAssessmentDropdown
                          classAssessments={classAssessments}
                          classIds={classIds}
                          teachers={teachers}
                          assessmentName={assessment.name}
                          assessment={assessment}
                          teacherid={teacherid}
                          schoolid={schoolid}
                          gradeLevel={gradeLevel}
                          allClassesAssessments={allClassesAssessments}
                        />
                      </Suspense>
                    </Col>
                    <Col className="d-flex justify-content-end align-items-center">
                      <Suspense
                        fallback={<div>Loading Recommendations...</div>}
                      >
                        <RecommendationsButton onResultsPage={true} />
                      </Suspense>
                      <Suspense fallback={<div>Loading score table...</div>}>
                        <ScoreInterpretationTable />
                      </Suspense>
                    </Col>
                  </Row>
                  <button
                    className="blue-button"
                    onClick={() =>
                      setShowChildPrintOptions(!showChildPrintOptions)
                    }
                  >
                    {showChildPrintOptions
                      ? "Hide Print Options"
                      : "View Print Options"}
                  </button>
                  {showChildPrintOptions && (
                    <div className="print-options">
                      <ReactToPrint
                        trigger={() => (
                          <button className="blue-button">
                            Print Class Averages
                          </button>
                        )}
                        content={() => individualChildRef.current}
                      />
                      {/* <ReactToPrint
                    trigger={() => <button className="blue-button">Print Standard Scores Graph</button>}
                    content={() => standardScoreGraphRef.current}
                  />
                  <ReactToPrint
                    trigger={() => <button className="blue-button">Print Progress Between Testing Points</button>}
                    content={() => candyBearRef.current}
                  /> */}
                    </div>
                  )}
                  <br></br>
                  <Tabs
                    defaultActiveKey="classAverageComparison"
                    id="class-average-sub-tabs "
                    style={{ marginBottom: '2rem' }}  // Add custom margin
                  >
                    {/* Class Average Tab with Class-Specific Data */}
                    {/* <Tab
                      eventKey="classAverage"
                      title="Class Average"
                      onSelect={(tab) => setActiveTab(tab)}
                    >
                      <div ref={individualChildRef}>
                        <Accordion
                          activeKey={activeAccordionKey}
                          onSelect={(key) => setActiveAccordionKey(key)}
                          defaultActiveKey="0"
                        >
                          {formattedClassData?.map((classData) => {
                            // Skip unwanted classes
                            if (
                              classData?.name?.toUpperCase()?.includes("SET")
                            ) {
                              return null;
                            }

                            // Ensure we get the correct class results
                            const classResults =
                              classesResults[classData.id] || {};

                            // Transform classResults into the required format for the component
                            const transformedAssessmentResults = Object.values(
                              classResults.students || {}
                            )
                              .map((student) => ({
                                student,
                                tasks: (student.results || []).flatMap(
                                  (result) =>
                                    result.groupedTasks.map((group) => ({
                                      name: group.name,
                                      score: group.aggregated?.score ?? 0,
                                      standardScore:
                                        group.aggregated?.standardScore ?? 0,
                                      zScore: group.aggregated?.zScore ?? 0,
                                      sTenScore:
                                        group.aggregated?.sTenScore ?? 0,
                                      duration: group.aggregated?.duration ?? 0,
                                    }))
                                ),
                              }))
                              .filter((student) => student.tasks.length > 0);

                            return (
                              <Accordion.Item
                                key={classData.id}
                                eventKey={String(classData.id)}
                              >
                                <Accordion.Header
                                  onClick={() =>
                                    !classesResults[classData.id] &&
                                    handleClick(classData.id)
                                  }
                                >
                                  {classData.name}
                                  {loadingClassId === classData.id && (
                                    <Fallback />
                                  )}
                                </Accordion.Header>
                                <Accordion.Body>
                                  {classResults ? (
                                    <CandyBearAnalysisGraphClassAverage
                                      selectedChild={selectedChild}
                                      setSelectedChildID={setSelectedChildID}
                                      individualStudentResult={
                                        individualStudentResult
                                      }
                                      assessmentResultsByStudent={
                                        transformedAssessmentResults
                                      }
                                      classId={classData.id}
                                      className={classData.name}
                                      classAssessments={classAssessments}
                                      gradeLevel={gradeLevel}
                                      schoolid={schoolid}
                                      teacherid={teacherid}
                                    />
                                  ) : (
                                    <div>
                                      Loading data or select this class to load
                                      data...
                                    </div>
                                  )}
                                </Accordion.Body>
                              </Accordion.Item>
                            );
                          })}
                        </Accordion>
                      </div>
                    </Tab> */}

                    {/* Class Average Comparison Tabs */}
                    <Tab
                      eventKey="classAverageComparison"
                      title="Class Average Comparison (Current Screener)"
                      onSelect={(tab) => setActiveTab(tab)} // Update state on tab change
                      onEnter={() => {
                        // Call handleClick for each class ID when tab is selected
                        classList.forEach((classItem) => {
                          if (!classesResults[classItem.classId]) {
                            // Prevent redundant calls
                            handleClick(classItem.classId);
                          }
                        });
                      }}
                    >
                      <div ref={individualChildRef}>
                        <div ref={candyBearRef}>
                          <CandyBearAnalysisGraphClassComparison
                            assessmentResultsByStudent={
                              assessmentResultsByStudent
                            } // Pass student results
                            formattedClassData={formattedClassData} // Pass all class results
                          />
                        </div>
                      </div>
                    </Tab>
                    <Tab
                      eventKey="classAverage"
                      title="Class Average"
                      onSelect={(tab) => setActiveTab(tab)}
                    >
                      <div ref={individualChildRef}>
                        <Accordion
                          activeKey={activeAccordionKey}
                          onSelect={(key) => setActiveAccordionKey(key)}
                          defaultActiveKey="0"
                        >
                          {formattedClassData?.map((classData) => {
                            // Skip unwanted classes
                            if (
                              classData?.name?.toUpperCase()?.includes("SET")
                            ) {
                              return null;
                            }

                            // Ensure we get the correct class results
                            const classResults =
                              classesResults[classData.id] || {};

                            // Transform classResults into the required format for the component
                            const transformedAssessmentResults = Object.values(
                              classResults.students || {}
                            )
                              .map((student) => ({
                                student,
                                tasks: (student.results || []).flatMap(
                                  (result) =>
                                    result.groupedTasks.map((group) => ({
                                      name: group.name,
                                      score: group.aggregated?.score ?? 0,
                                      standardScore:
                                        group.aggregated?.standardScore ?? 0,
                                      zScore: group.aggregated?.zScore ?? 0,
                                      sTenScore:
                                        group.aggregated?.sTenScore ?? 0,
                                      duration: group.aggregated?.duration ?? 0,
                                    }))
                                ),
                              }))
                              .filter((student) => student.tasks.length > 0);

                            return (
                              <Accordion.Item
                                key={classData.id}
                                eventKey={String(classData.id)}
                              >
                                <Accordion.Header
                                  onClick={() =>
                                    !classesResults[classData.id] &&
                                    handleClick(classData.id)
                                  }
                                >
                                  {classData.name}
                                  {loadingClassId === classData.id && (
                                    <Fallback />
                                  )}
                                </Accordion.Header>
                                <Accordion.Body>
                                  {classResults ? (
                                    <CandyBearAnalysisGraphClassAverage
                                      selectedChild={selectedChild}
                                      setSelectedChildID={setSelectedChildID}
                                      individualStudentResult={
                                        individualStudentResult
                                      }
                                      assessmentResultsByStudent={
                                        transformedAssessmentResults
                                      }
                                      classId={classData.id}
                                      className={classData.name}
                                      classAssessments={classAssessments}
                                      gradeLevel={gradeLevel}
                                      schoolid={schoolid}
                                      teacherid={teacherid}
                                    />
                                  ) : (
                                    <div>
                                      Loading data or select this class to load
                                      data...
                                    </div>
                                  )}
                                </Accordion.Body>
                              </Accordion.Item>
                            );
                          })}
                        </Accordion>
                      </div>
                    </Tab>
                  </Tabs>
                </Tab>

                {isStaging && (
                  <Tab
                    eventKey="progress"
                    title="Progress"
                    className="mb-4"
                  >
                    <Row className="page-description-bar align-items-center">
                      <Col className="d-flex justify-content-end align-items-center">
                        <Suspense fallback={<div>Loading Recommendations...</div>}>
                          <RecommendationsButton onResultsPage={true} />
                        </Suspense>
                        <Suspense fallback={<div>Loading score table...</div>}>
                          <ScoreInterpretationTable />
                        </Suspense>
                      </Col>
                    </Row>

                    {(() => {
                      const { isAvailable, currentTime, dayOfWeek } = getProgressTabStatus();

                      if (!isAvailable) {
                        return (
                          <Alert variant="warning" className="text-center mb-4">
                            <FontAwesomeIcon icon={faClock} className="me-2" />
                            <strong>Progress Analysis shows a child's % reading score progress over all screening points.</strong>
                            <p className="mb-0 mt-2">
                              Progress analysis is only available after 1:30 PM on weekdays, and anytime on weekends.
                            </p>
                            <div className="small mt-1">
                              Current time (Ireland): {currentTime} - {dayOfWeek}
                            </div>
                          </Alert>
                        );
                      }

                      return (
                        <Tabs
                          defaultActiveKey="screeningProgressComparison"
                          id="class-progress-sub-tabs"
                          style={{ marginBottom: '2rem' }}
                        >
                          {/* Screening Progress Tab */}
                          <Tab
                            eventKey="screeningProgressComparison"
                            title="Screening Point"
                          >
                            <div ref={individualChildRef}>
                              <h4 className="mt-5 mb-3">Class Screening Progress</h4>
                              <Accordion
                                onSelect={(key) => {
                                  setActiveAccordionKey(key);
                                  if (key && !openedAccordions.has(key)) {
                                    setOpenedAccordions(prev => new Set([...prev, key]));
                                  }
                                }}
                              >
                                {formattedClassData.map((classData) => {
                                  if (classData.name.toUpperCase().includes("SET")) {
                                    return null;
                                  }

                                  return (
                                    <Accordion.Item
                                      key={classData.id}
                                      eventKey={String(classData.id)}
                                    >
                                      <Accordion.Header>
                                        {classData.name}
                                        {loadingClassId === classData.id && <Fallback />}
                                      </Accordion.Header>
                                      <Accordion.Body>
                                        {openedAccordions.has(String(classData.id)) ? (
                                          <Suspense fallback={
                                            <div className="text-center p-3">
                                              <BigSpinner />
                                              <p>Loading screening data...</p>
                                            </div>
                                          }>
                                            <ScreenerPieCharts
                                              schoolId={schoolid}
                                              classId={classData.id}
                                              className={classData.name}
                                              timeframe={YEAR_RANGES[academicYear]}
                                              isJunior={!classDetails?.grade_level2}
                                            />
                                          </Suspense>
                                        ) : (
                                          <div className="text-center p-3">
                                            <p>Click to expand and load screening progress data...</p>
                                          </div>
                                        )}
                                      </Accordion.Body>
                                    </Accordion.Item>
                                  );
                                })}
                              </Accordion>
                            </div>
                          </Tab>

                          {/* Classroom Progress Tab - Only loads when selected */}
                          <Tab
                            eventKey="classroomProgress"
                            title="Classroom"
                          >
                            <Suspense fallback={
                              <div className="text-center p-4">
                                <BigSpinner />
                                <p>Loading classroom progress component...</p>
                              </div>
                            }>
                              <ClassroomProgressTabContent
                                selectedAssessmentIds={selectedAssessmentIds}
                                schoolid={schoolid}
                                YEAR_RANGES={YEAR_RANGES}
                                academicYear={academicYear}
                                individualChildRef={individualChildRef}
                              />
                            </Suspense>
                          </Tab>
                        </Tabs>
                      );
                    })()}
                  </Tab>
                 )} 

                <Tab eventKey="Not Screened" title="Screening Status">
                  <>
                    {isLoading ? (
                      <div className="spinner-container">
                        <div className="big-ball-spinner"></div>
                      </div>
                    ) : (
                      <>
                        <Row className="page-description-bar align-items-center">
                          <Col className="col-auto">
                            <Suspense
                              fallback={
                                <div>Loading Assessment Dropdown...</div>
                              }
                            >
                              <SencoAssessmentDropdown
                                classAssessments={classAssessments}
                                classIds={classIds}
                                teachers={teachers}
                                assessmentName={assessment.name}
                                assessment={assessment}
                                teacherid={teacherid}
                                schoolid={schoolid}
                                gradeLevel={gradeLevel}
                                allClassesAssessments={allClassesAssessments}
                              />
                            </Suspense>
                          </Col>
                          <Col className="d-flex justify-content-end align-items-center">
                            <Suspense
                              fallback={<div>Loading Recommendations...</div>}
                            >
                              <RecommendationsButton onResultsPage={true} />
                            </Suspense>
                            <Suspense
                              fallback={<div>Loading score table...</div>}
                            >
                              <ScoreInterpretationTable />
                            </Suspense>
                          </Col>
                        </Row>
                        <Accordion
                          defaultActiveKey="0"
                          className="accordion-container"
                        >
                          {classList.map((classItem, index) => {
                            const { classId, name } = classItem;
                            if (name.toUpperCase().includes("SET")) {
                              return null;
                            }

                            return (
                              <Accordion.Item
                                eventKey={String(index)}
                                key={classId}
                                className="accordion-item-results"
                              >
                                <Accordion.Header
                                  onClick={(e) => {
                                    handleAccordionToggle(
                                      String(index),
                                      activeAccordionRef,
                                      name,
                                      classId
                                    );
                                    if (
                                      !e.target.closest(
                                        ".accordion-actions-icon"
                                      )
                                    ) {
                                      handleClick(classId);
                                    }
                                  }}
                                >
                                  <div className="d-flex justify-content-between w-100 align-items-center">
                                    <span>{name}</span>
                                  </div>
                                  {loadingClassId === classId && <Fallback />}
                                </Accordion.Header>
                                <Accordion.Body>
                                  {classesResults[classId] ? (
                                    <Suspense
                                      fallback={
                                        <div>Loading not screened data...</div>
                                      }
                                    >
                                      <NotScreenedTab
                                        classesResults={{
                                          [classId]: classesResults[classId],
                                        }} // Pass only the relevant class results
                                        schoolid={schoolid}
                                        teacherid={teacherid}
                                        classId={classId}
                                        assessment={assessment}
                                        // classDetails={classDetails}
                                        // readingScores={readingScores}
                                        classAssessments={classAssessments}
                                        gradeLevel={gradeLevel}
                                        // assessmentResultsByStudent={
                                        //   assessmentResultsByStudent
                                        // }
                                        fromSencoResults={fromSencoResults}
                                        // activeAccordionStudents={
                                        //   activeAccordionStudents
                                        // }
                                        // activeAccordionKey={activeAccordionKey}
                                        // setStudentResults={setStudentResults}
                                        // activeAccordionClassId={
                                        //   activeAccordionClassId
                                        // }
                                        students={students}
                                      />
                                    </Suspense>
                                  ) : (
                                    <p>Loading data for this class...</p>
                                  )}
                                </Accordion.Body>
                              </Accordion.Item>
                            );
                          })}
                        </Accordion>
                      </>
                    )}
                  </>
                </Tab>
              </Tabs>
            </Suspense>
          </Container>
        </div>
      </div>
      {openCard === "printCard" && (
        <ReportActionCard
          cardPosition={printCardPosition}
          handleCloseCard={() => toggleCard("printCard")}
          activeAccordionRef={activeAccordionRef}
          activeAccordionStudents={activeAccordionStudents}
          toAllStudentResults={toAllStudentResults}
          toReportCards={toReportCards}
          activeAccordionClassId={activeAccordionClassId}
          setViewParent={setViewParent}
          setViewTeacher={setViewTeacher}
          assessmentName={assessment?.name}
        />
      )}
      {openCard === "shareCard" && (
        <ShareActionCard
          cardPosition={shareCardPosition}
          handleCloseCard={() => toggleCard("shareCard")}
          activeAccordionRef={activeAccordionRef}
          activeAccordionStudents={activeAccordionStudents}
          shareResults={(zipBlob) => {
            console.log("Sharing ZIP Blob:", zipBlob);
          }}
          assessmentName={assessment?.name || "Assessment"}
          className={activeClassName || "Class"}
          rollNumber={schoolid || "School"}
          setViewParent={setViewParent}
          setViewTeacher={setViewTeacher}
          schoolid={schoolid}
          teacherId={teacherid}
          assessmentId={assessment?.id}
        />
      )}
      {accordionSelectedClass && openCard === "actionCard" && (
        <ActionCard
          selectedStudent={accordionSelectedClass}
          taskList={classTaskList.map((task) => ({
            name: task.name,
            answerid: task.name, // Use name as the identifier since that's what we're tracking in selectedTasks
          }))}
          selectedTasks={selectedClassTasks}
          selectAll={selectAllClassTasks}
          showTaskList={showClassTaskList}
          cardPosition={accordionCardPosition}
          actionCardRef={accordionActionCardRef}
          handleCloseCard={() => toggleCard("actionCard")}
          setShowTaskList={setShowClassTaskList}
          handleTaskSelection={handleClassTaskSelection}
          handleSelectAll={handleSelectAllClassTasks}
          handleRetake={handleClassRetake}
          toAllStudentResults={toAllStudentResults}
          setViewParent={setViewParent}
          setViewTeacher={setViewTeacher}
          assessmentName={assessment?.name}
        />
      )}
      {classTaskToDelete && openCard === "deleteModal" && (
        <DeleteAnswerModal
          show={showClassDeleteModal}
          handleClose={() => {
            setShowClassDeleteModal(false);
            toggleCard("deleteModal");
          }}
          taskName={classTaskToDelete.taskName}
          studentName={accordionSelectedClass?.name || "Selected Class"}
          assessmentName={assessment?.name || "Assessment"}
          handleDelete={handleClassDeleteSuccess}
          answerIds={classTaskToDelete.answerIds}
          teacherid={teacherid}
          isRetakeFullAssessment={classTaskToDelete.isFullAssessment}
          isClassLevel={true} // This prop is missing
        />
      )}
      {openCard === "printActionCard" && (
        <PrintActionCardSenco
          cardPosition={printActionCardPosition}
          handleCloseCard={() => toggleCard("printActionCard")}
          activeAccordionRef={activeAccordionRef}
          academicYear={academicYear}
          className={activeClassName}
          assessmentName={assessment.name}
        />
      )}
    </>
  );
}

export default SencoStudentsResultsOverview;
